import $ from 'jquery';
import 'slick-carousel';

/**
 * Slick image carousel functionality. Image carousel is used for example in meeting and party restaurant page hero section.
 */

const imageCarousel = {
  // This is defined in css and setCarouselHeight function initializes it.
  carouselHeight: 0,
  // This is defined in css and setCarouselWidth function initializes it.
  carouselWidth: 0,
  // This is defined in backend and setShowMoreLimit function initializes it.
  showMoreLimit: 0,

  /**
   * Centers images inside carousel image-wrapper.
   */
  _centerImages: function() {
    const self = this;
    // Loop carousel images
    $('.images .image').each(function() {
      // If image width is bigger than carousel
      if(this.width > self.carouselWidth) {
        // Set negative margin-left so img is centered
        $(this).css('margin-left', '-' + ((this.width - self.carouselWidth) / 2) + 'px');
      } else {
        $(this).css('margin', '0 auto');
      }
    });
  },

  /**
   * Gets thumbnail by index.
   *
   * @param {number} index Index of thumnbail
   * @return {jQuery} Thumbnail jQuery element
   */
  _getThumbnailByIndex: function(index) {
    return $('.image-carousel .thumbnails .thumbnail[data-index="'+ index +'"]');
  },

  /**
   * Toggles active class for element.
   *
   * @param {jQuery} $element jQuery element.
   */
  _toggleActiveClass: function($element) {
    $element.toggleClass('active');
  },

  /*
    * Changes active thumbnail in the grid based on carousel's current slide.
    * Basically toggles active class of thumbnail's based on slide indexes.
    *
    * @param currentSlide Current slide index in carousel
    * @param nextSlide Next slide index in carousel
    */
  _changeActiveThumbnail: function(currentSlide,nextSlide) {
    this._toggleActiveClass(this._getThumbnailByIndex(currentSlide));
    this._toggleActiveClass(this._getThumbnailByIndex(nextSlide));
  },

  /**
   * Modifies thumbnail's dom to show all thumbnails.
   */
  _showAllImages: function() {
    $('.image-carousel .thumbnails .hidden').removeClass('hidden');
    $('.image-carousel .thumbnails .show-all').remove();
  },

  /**
   * Sets carousel height which is defined in css.
   */
  _setCarouselHeight: function() {
    this.carouselHeight = $('.image-carousel .images').height();
  },

  /**
   * Sets carousel height which is defined in css.
   */
  _setCarouselWidth: function() {
    this.carouselWidth = $('.image-carousel .images').width();
  },

  /**
   * Sets show more limit. Limit is defined in backend and printed to data-attribute of show more button.
   */
  _setShowMoreLimit: function() {
    this.showMoreLimit = $('.image-carousel .thumbnails .show-all').data('show-more-limit');
  },

  init: function() {

    // If image carousel is found.
    if($('.image-carousel').length > 0) {

      var self = this;

      // When document is ready
      $(function() {

        // Initialize variables
        self._setCarouselHeight();
        self._setCarouselWidth();
        self._setShowMoreLimit();

        // Initialize image carousel
        $('.image-carousel .images').slick({
          prevArrow: '.slick-arrow.slick-prev',
          nextArrow: '.slick-arrow.slick-next'
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          // Before slide changes toggle active classes for current and next thumbnail
          if(nextSlide >= self.showMoreLimit) {
            self._showAllImages();
          }
          self._changeActiveThumbnail(currentSlide,nextSlide);
        });

        // Set first thumbnail to active.
        self._toggleActiveClass(self._getThumbnailByIndex(0));

        // Click event for thumbnail
        $('.image-carousel .thumbnails .thumbnail').on('click', function() {
          // Change current slide to slide in clicked thumbnail index
          $('.image-carousel .images').slick('slickGoTo',$(this).data('index'));
        });

        // Click event for show all images
        $('.image-carousel .thumbnails .show-all').on('click', function() {
          self._showAllImages();
        });

        // When window is resized
        var resizeTimeout;
        $(window).on('resize',function(e) {
          self._setCarouselWidth();
          clearTimeout(resizeTimeout);
          // Center images horizontally inside carousel
          resizeTimeout = setTimeout(function() {
            self._centerImages();
          },500);
        });

        // When document is ready center images horizontally
        self._centerImages();
      });
    }
  }
}

export default imageCarousel;
